import { FormCard } from '@portal_components/components/FormCard';
import { FormTextInput } from '@portal_components/components/FormTextInput';
import { BulkAssignListForm } from '../../types';

interface BulkAssignAddressDetailsTabProps {
  index: number;
}

export const BulkAssignAddressDetailsTab = ({ index }: BulkAssignAddressDetailsTabProps) => {
  return (
    <FormCard columns={2}>
      <FormTextInput<BulkAssignListForm>
        title="Property Name"
        name={`siteList.${index}.address.addressName`}
        mandatory
      />
      <FormTextInput<BulkAssignListForm>
        title="Address Line 1"
        name={`siteList.${index}.address.addressLine1`}
        mandatory
      />
      <FormTextInput<BulkAssignListForm>
        title="Address Line 2"
        name={`siteList.${index}.address.addressLine2`}
      />
      <FormTextInput<BulkAssignListForm>
        title="Address Line 3"
        name={`siteList.${index}.address.addressLine3`}
      />
      <FormTextInput<BulkAssignListForm> title="Town" name={`siteList.${index}.address.town`} mandatory />
      <FormTextInput<BulkAssignListForm> title="County" name={`siteList.${index}.address.county`} mandatory />
      <FormTextInput<BulkAssignListForm>
        title="Postcode"
        name={`siteList.${index}.address.postcode`}
        mandatory
      />
    </FormCard>
  );
};
